export default __webpack_public_path__ + "static/media/trophy-bronze.22cb5c8b.svg";